module.exports = {"domain":"https://us-central1-iota-documentation.cloudfunctions.net","siteRoot":"https://iota-documentation.firebaseapp.com"}


//////////////////
// WEBPACK FOOTER
// D:/Workarea/iota.org/documentation/src/config.json
// module id = 158
// module chunks = 0 1 2 3